/**
 * Fire-and-forget dispatch to /api/track-event (server/routes/track-event.ts), the full-coverage
 * counterpart to GA4/Ahrefs for events that never trigger a Discord business signal. Same-origin,
 * so the session cookie and the jc_aid guest-identity cookie attach automatically — no need to
 * read either cookie in JS. Callers (analytics.ts) are responsible for consent-gating and for
 * skipping CHOKEPOINT_COVERED_EVENT_NAMES; this file just sends what it's given.
 */
export function sendTrackEventBeacon(eventName: string, params: Record<string, unknown>): void {
  if (typeof window === "undefined") return;

  try {
    const body = JSON.stringify({ eventName, params });
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const sent = navigator.sendBeacon("/api/track-event", new Blob([body], { type: "application/json" }));
      if (sent) return;
    }
    // sendBeacon unavailable or its own queue rejected the payload (e.g. over its size cap) —
    // fall back to a keepalive fetch, which survives page unload the same way sendBeacon does.
    void fetch("/api/track-event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Never let a tracking failure surface to the caller — same contract as trackEvent() itself.
  }
}
